import ContentLayout from '@/layouts/content-layout'
import BankPaymentView from '@/sections/bank-payment/view/bank-payment-view'

export default function BankPaymentPage() {
  return (
    <ContentLayout title="จัดการบัญชี">
      <BankPaymentView />
    </ContentLayout>
  )
}
